import { Image, StyleSheet, Text, View } from '@react-pdf/renderer';
import moment from 'moment';
import webLogo from '../../../img/web-logo.png';

const styles = StyleSheet.create({
  headerContainer: {
    backgroundColor: '#F8FAFC',
    paddingVertical: 6,
    paddingHorizontal: 18,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottomWidth: 1,
    borderBottomColor: '#CBD5E1',
    marginBottom: 3,
  },
  leftSection: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  logoContainer: {
    width: 32,
    height: 32,
    borderRadius: 16,
    backgroundColor: '#FFFFFF',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 10,
    borderWidth: 0.75,
    borderColor: '#CBD5E1',
  },
  logoImage: {
    width: 24,
    height: 24,
    objectFit: 'contain',
  },
  headerTextContainer: {
    flexDirection: 'column',
  },
  mainHeaderText: {
    fontSize: 8,
    fontFamily: 'Helvetica',
    color: '#000000',
  },
  subHeaderText: {
    fontSize: 8,
    fontFamily: 'Helvetica',
    color: '#000000',
    marginTop: 1,
  },
  rightSection: {
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'center',
  },
  dateText: {
    fontSize: 8,
    fontFamily: 'Helvetica',
    color: '#000000',
  },
});

const PdfHeader = () => {
  return (
    <View style={styles.headerContainer}>
      <View style={styles.leftSection}>
        <View style={styles.logoContainer}>
          <Image source={webLogo} style={styles.logoImage} />
        </View>
        <View style={styles.headerTextContainer}>
          <Text style={styles.mainHeaderText}>Smart Sea Freight</Text>
          <Text style={styles.subHeaderText}>Maritime Cargo Manifest & Voyage Calculation</Text>
        </View>
      </View>
      <View style={styles.rightSection}>
        <Text style={styles.dateText}>{moment().format('DD MMM YYYY • hh:mm A')}</Text>
      </View>
    </View>
  );
};

export default PdfHeader;